import { render, staticRenderFns } from "./404.vue?vue&type=template&id=838c4c96&scoped=true"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=838c4c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838c4c96",
  null
  
)

export default component.exports